import React from 'react';
import PropTypes from 'prop-types';
import {replaceAssetsImgUrl} from 'cms/helpers/common';

const BenefitColumn = ({bgImage, url, header, text}) => {
  return (
    <div className="grid-item-sm text-white">
      <img
        className="position-absolute w-1-1 h-1-1 img-cover"
        src={replaceAssetsImgUrl(bgImage, 370)}
      />
      <div className="position-relative p-4 m-4 bg-primary-soft">
        <a
          href={url}
          className="display-4 text-white font-bold text-decoration-none"
          target="_blank"
          rel="noreferrer"
        >{header}</a>
        {text && <div className="my-2">{text}</div>}
      </div>
    </div>
  );
};
  
BenefitColumn.propTypes = {
  bgImage: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
  text: PropTypes.string
};

export default BenefitColumn;